module.exports = __webpack_public_path__ + "build/desktop/a/img/insurance.01b5c93cfdc34f46afc274f310cef39e.svg";